import api from "app/lib/api";
import endpoints from "static/endpoints";

export const getImplantElectronicDevice = async () => {
  const {
    data: { manufacturer, device },
  } = await api.get(endpoints.dashboard.implantElectronicDevice);

  return { manufacturer, device };
};
